/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, debounce, isEqual, isFunction } from 'lodash';

// Components
import BaseControl from './BaseControl.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import LanguageSelect from 'shared/ui/components/form-components/pickers/LanguageSelect.vue';
import VideoCallItemUploader from './VideoCallItemUploader.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import VideoCallRecordings from './VideoCallRecordings.vue';

// As per ACS restrictions, it need to have the region code.
// Revisit periodically as we update the ACS SDK
const CAPTIONS_LANGUAGES = [
    'ar-SA',
    'zh-HK',
    'zh-CN',
    'da-DK',
    'nl-BE',
    'nl-NL',
    'en-AU',
    'en-CA',
    'en-IN',
    'en-GB',
    'en-US',
    'fi-FI',
    'fr-CA',
    'fr-FR',
    'de-DE',
    'hi-IN',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NO',
    'pl-PL',
    'pt-BR',
    'ru-RU',
    'es-MX',
    'es-ES',
    'sv-SE'
];

const MODERATOR_OPTIONS = { all: 'all', custom: 'custom' };

const __vue_script__ = {
    name: 'VideoCallControl',

    components: {
        BaseInput,
        LoaderButton,
        Toggler,
        LanguageSelect,
        VideoCallItemUploader,
        RadioButtons,
        VideoCallRecordings
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        settings: {
            type: Object,
            required: true
        },

        model: {
            type: Object,
            required: true
        },

        edit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            canJoinCall: false,
            loading: false,
            videoCallDoc: null,
            moderatorField: {
                video_call_moderators: {
                    'field': 'video_call_moderators',
                    'noLabel': true,
                    'name': 'video_call_moderators',
                    'kind': 'external',
                    'kind_options': {
                        'type': 'person',
                        'id_field': 'fp_ext_id',
                        'maxNumber': 5
                    }
                }
            },
            moderatorOptions: [{
                value: MODERATOR_OPTIONS.all,
                label: this.$t('generic_form.video.all_moderators')
            }, {
                value: MODERATOR_OPTIONS.custom,
                label: this.$t('generic_form.video.custom_moderators')
            }],
            moderatorValue: MODERATOR_OPTIONS.all,
            originalDoc: cloneDeep(this.model),
            possibleCaptionsLanguages: CAPTIONS_LANGUAGES,
            hasUnsavedSlideshowChanges: false,
            unsubscribers: [],
            hasUnsavedVirtualBackgroundChanges: false,
            pendingSlideshowsPartialSave: false,
            pendingVirtualBackgroundsPartialSave: false,
            savePartiallyDebounced: debounce(() => this.savePartially(), 1000),
            slideShowAttachmentSpecs: this.$utils.metadata.getAttachmentSpecs({}, ['application/pdf'], 1024 ** 2 * 150), // 150MiB
            backgroundAttachmentSpecs: this.$utils.metadata.getAttachmentSpecs({}, ['image/jpeg', 'image/png'], 1024 ** 2 * 3) // 3MiB
        };
    },

    computed: {
        /** @returns {boolean} */
        enabled() {
            return this.edit && this.name === 'video_breakout_id';
        },

        /** @returns {boolean} */
        isCallScheduled() {
            return this.videoCallDocId && this.model?.video_call_enabled;
        },

        videoCallDocId() {
            return this.model?.[this.name];
        },

        videoCallHintTimes() {
            const start = this.videoCallDoc?.videoSessionConfig?.fromTimestampSecs;
            const end = this.videoCallDoc?.videoSessionConfig?.toTimestampSecs;

            if (!start || !end) {
                return '';
            }

            return this.$i18n.t('generic_form.video.hint', [
                this.$utils.time.convertTimestampToHumanForm(start),
                this.$utils.time.convertTimestampToHumanForm(end)
            ]);
        },

        everyoneIsModerator() {
            return this.moderatorValue === MODERATOR_OPTIONS.all;
        },

        slideshowIds() {
            return this.videoCallDoc?.slideshow_ids;
        },

        virtualBackgroundIds() {
            return this.videoCallDoc?.virtual_background_ids;
        }
    },

    watch: {
        model: {
            immediate: true,
            async handler() {
                if (!this.videoCallDocId) {
                    this.videoCallDoc = null;
                } else {
                    await this.fetchVideoCallDoc();
                }
            }
        },

        videoCallDoc: {
            deep: true,
            immediate: false,
            handler() {
                // this is needed to be able to batch edit video calls by excel export/import
                if (this.videoCallDoc.embedded_url_enabled !== this.model.video_call_embedded_url_enabled) {
                    this.$emit('input', 'video_call_embedded_url_enabled', this.videoCallDoc.embedded_url_enabled);
                }

                if (this.videoCallDoc.embedded_url !== this.model.video_call_embedded_url) {
                    this.$emit('input', 'video_call_embedded_url', this.videoCallDoc.embedded_url);
                }
            }
        },

        slideshowIds(newVal, oldVal) {
            if (newVal && oldVal && !isEqual(newVal, oldVal)) {
                const containSameElements = isEqual([...newVal].sort(), [...oldVal].sort());
                if (containSameElements) {
                    // Slideshows have been reordered. Request manual saving
                    this.hasUnsavedSlideshowChanges = true;
                    return;
                }

                // There's been some additions or removals. Save automatically
                this.pendingSlideshowsPartialSave = true;
                this.savePartiallyDebounced();
            }
        },

        virtualBackgroundIds(newVal, oldVal) {
            if (newVal && oldVal && !isEqual(newVal, oldVal)) {
                const containSameElements = isEqual([...newVal].sort(), [...oldVal].sort());
                if (containSameElements) {
                    // Images have been reordered. Request manual saving
                    this.hasUnsavedVirtualBackgroundChanges = true;
                    return;
                }

                // There's been some additions or removals. Save automatically
                this.pendingVirtualBackgroundsPartialSave = true;
                this.savePartiallyDebounced();
            }
        }
    },

    async created() {
        if (!this.enabled) {
            return;
        }

        this.canJoinCall = this.$services.user.hasPermission('node_crud_realms.read_event_data', { event_id: this.event._id, org_id: this.event.ownerId });

        this.unsubscribers.push(
            await this.$services.signal.addSignalListener(
                'document/video_call/update',
                (signal) => {
                    if (!this.videoCallDoc || signal.targetId !== this.videoCallDocId) {
                        return;
                    }
                    console.debug('[VideoControl] Upload completed and processed', signal);

                    this.videoCallDoc.fp_attachments_s3 = signal.document?.fp_attachments_s3 || this.videoCallDoc?.fp_attachments_s3;
                }),
            this.$services.signal.addEventListener('open', () => this.fetchVideoCallDoc())
        );
    },


    beforeDestroy() {
        this.unsubscribers.forEach(unsubscriber => {
            if (isFunction(unsubscriber)) {
                unsubscriber();
            }
        });
        this.unsubscribers = [];
    },

    methods: {
        async scheduleCall() {
            try {
                if (this.loading) return;

                if (this.model.live_stream || this.originalDoc.live_stream) {
                    this.$modal.show('dialog', {
                        title: this.$i18n.t('general.error_occurred'),
                        text: this.$i18n.t('generic_form.video.error_other_stream'),
                        buttons: [{
                            title: this.$i18n.t('general.close'),
                            default: true,
                            class: 'btn'
                        }]
                    });
                    return;
                }

                this.loading = true;

                const data = await this.$services.videoCalls.schedule(this.event.id, this.model._id);
                this.$emit('input', 'video_breakout_id', data[this.name]);
                this.$emit('input', 'video_call_enabled', true);

                if (data._rev !== this.model._rev) {
                    this.$emit('rev', data._rev);
                }

                let videoType;
                if (this.model.fp_type === 'session') {
                    videoType = 'session-breakout';
                } else if (this.model.fp_type === 'sponsor') {
                    videoType = 'sponsor-booth';
                }

                this.$services.track.track('video-call-schedule', {
                    id: data[this.name],
                    type: videoType
                });

                await this.fetchVideoCallDoc();
            } catch (error) {
                console.error('[VideoCallControl] An error occurred while scheduling the call', error);
                this.$notify({
                    group: 'flashes',
                    text: error?.data?.error ?? this.$i18n.t('generic_form.video.error_scheduling').toString(),
                    type: 'error',
                });

            } finally {
                this.loading = false;
            }
        },

        async cancelCall() {
            try {
                if (this.loading || !this.videoCallDocId) return;

                this.loading = true;

                const data = await this.$services.videoCalls.cancel(this.event._id, this.model._id);

                if (data._rev !== this.model._rev) {
                    this.$emit('input', 'video_breakout_id', null);
                    this.$emit('input', 'video_call_enabled', false);
                    this.$emit('rev', data._rev);
                    this.$emit('behaviour', { afterSave: () => {} });
                }
            } catch (error) {
                console.error('[VideoCallControl] An error occurred while cancelling the call', error.message);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('generic_form.video.error_cancelling').toString(),
                    type: 'error',
                });
            } finally {
                this.loading = false;

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('generic_form.video.success_cancelling').toString(),
                    type: 'success',
                });
            }
        },

        async joinCall() {
            if (this.loading || !this.videoCallDocId) return;

            const webappUrl = await this.$services.user.getWebappLoginUrl(this.event._id, `/view/${this.model.fp_type}/${this.model._id}`);

            window.open(webappUrl, '_blank');
        },

        async fetchVideoCallDoc() {
            try {
                this.videoCallDoc = await this.$services.videoCalls.getDoc(this.event._id, this.videoCallDocId);
            } catch (error) {
                return this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('generic_form.video.error_loading').toString(),
                    type: 'error',
                });
            }

            let beforeChangeVideoCallDoc = cloneDeep(this.videoCallDoc);
            let beforeChangeModerators = cloneDeep(this.model.video_call_moderators || []);
            const beforeChangeEveryoneIsModerator = this.videoCallDoc.everyone_is_moderator;
            this.moderatorValue = beforeChangeEveryoneIsModerator ? MODERATOR_OPTIONS.all : MODERATOR_OPTIONS.custom;

            this.$emit('behaviour', {
                beforeSave: async () => {

                    if (!this.videoCallDoc) {
                        return;
                    }

                    const afterSaveModerators = cloneDeep(this.model.video_call_moderators || []);
                    const afterSaveEveryoneIsModerator = this.everyoneIsModerator;
                    this.videoCallDoc.everyone_is_moderator = afterSaveEveryoneIsModerator;
                    this.videoCallDoc.moderators = afterSaveModerators;
                    this.videoCallDoc.chat_moderated = !afterSaveEveryoneIsModerator && this.videoCallDoc.chat_moderated;

                    if (!isEqual(beforeChangeModerators, afterSaveModerators) || beforeChangeEveryoneIsModerator !== afterSaveEveryoneIsModerator) {
                        this.$services.videoCalls.notifyOnModeratorChange(this.event._id, this.model._id, afterSaveModerators, afterSaveEveryoneIsModerator)
                            .catch(error => {
                                console.error('[VideoCallControl] Could not notify moderator change', error.message);
                            });
                    }

                    this.videoCallDoc.embedded_url_enabled = !!this.videoCallDoc.embedded_url_enabled;
                    const hasChanged = !isEqual(beforeChangeVideoCallDoc, this.videoCallDoc);
                    if (!hasChanged && !afterSaveModerators.length) { // we want to also save if moderators is different than empty array, to migrate this variable to the videoCallDoc
                        return;
                    }

                    if (this.videoCallDoc.embedded_url) {
                        this.videoCallDoc.embedded_url = this.$utils.url.transformToEmbeddedUrls(this.videoCallDoc.embedded_url);
                    }

                    let { data: { _rev } } = await this.$services.videoCalls.updateDoc(this.event._id, this.videoCallDoc);
                    this.videoCallDoc._rev = _rev;
                    beforeChangeVideoCallDoc = cloneDeep(this.videoCallDoc);

                    this.hasUnsavedSlideshowChanges = false;
                    this.hasUnsavedVirtualBackgroundChanges = false;

                    this.pendingSlideshowsPartialSave = false;
                    this.pendingVirtualBackgroundsPartialSave = false;
                }
            });
        },

        async savePartially() {
            const toUpdate = await this.$services.videoCalls.getDoc(this.event._id, this.videoCallDocId);

            if (!this.pendingSlideshowsPartialSave && !this.pendingVirtualBackgroundsPartialSave) {
                return;
            }

            let savingSlideshows = this.pendingSlideshowsPartialSave;
            let savingVirtualBackgrounds = this.pendingVirtualBackgroundsPartialSave;

            if (this.pendingSlideshowsPartialSave) {
                toUpdate.slideshow_ids = this.slideshowIds;
                // New ids have been marked for update. Subsequent changes will need this flag off in order to be saved
                this.pendingSlideshowsPartialSave = false;
            }

            if (this.pendingVirtualBackgroundsPartialSave) {
                toUpdate.virtual_background_ids = this.virtualBackgroundIds;
                // New ids have been marked for update. Subsequent changes will need this flag off in order to be saved
                this.pendingVirtualBackgroundsPartialSave = false;
            }

            const { data: { _rev } } = await this.$services.videoCalls.updateDoc(this.event._id, toUpdate);
            this.videoCallDoc._rev = _rev;

            if (savingSlideshows) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('generic_form.video.slides_saved').toString(),
                    type: 'success',
                });

                this.hasUnsavedSlideshowChanges = false;
            }

            if (savingVirtualBackgrounds) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('generic_form.video.virtual_backgrounds_saved').toString(),
                    type: 'success',
                });

                this.hasUnsavedSlideshowChanges = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('control-decorator',{staticClass:"video-call",attrs:{"errors":_vm.errors,"label":_vm.label,"uid":_vm.uid,"dependant":_vm.dependant}},[(!_vm.isCallScheduled)?_c('loader-button',{attrs:{"disabled":_vm.loading,"status":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.scheduleCall.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('generic_form.video.schedule')))]):_vm._e(),(_vm.canJoinCall && _vm.isCallScheduled)?_c('loader-button',{staticClass:"success",attrs:{"disabled":_vm.loading,"status":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.joinCall.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('generic_form.video.join')))]):_vm._e(),(_vm.isCallScheduled)?_c('loader-button',{staticClass:"danger",attrs:{"disabled":_vm.loading,"status":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.cancelCall.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('generic_form.video.cancel')))]):_vm._e(),(_vm.videoCallHintTimes)?_c('div',{staticClass:"video-call-duration-hint"},[_vm._v(_vm._s(_vm.videoCallHintTimes))]):_vm._e(),(_vm.isCallScheduled)?_c('div',{staticClass:"video-call-settings"},[(_vm.videoCallDoc)?[_c('toggler',{attrs:{"name":"chat_enabled","on-label":"generic_form.video.chat_enabled","off-label":"generic_form.video.chat_enabled"},model:{value:(_vm.videoCallDoc.chat_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "chat_enabled", $$v)},expression:"videoCallDoc.chat_enabled"}},[(_vm.videoCallDoc.chat_enabled)?_c('div',{staticClass:"feature-dependant chat-moderated-toggle"},[_c('toggler',{attrs:{"disabled":_vm.everyoneIsModerator,"name":"chat_moderated","on-label":"generic_form.video.chat_moderated","off-label":"generic_form.video.chat_moderated","inline-tip":_vm.$t('generic_form.video.chat_moderated_tooltip')},model:{value:(_vm.everyoneIsModerator ? false : _vm.videoCallDoc.chat_moderated),callback:function ($$v) {_vm.$set(_vm.everyoneIsModerator ? false : _vm.videoCallDoc, "chat_moderated", $$v)},expression:"everyoneIsModerator ? false : videoCallDoc.chat_moderated"}})],1):_vm._e()]),_c('toggler',{attrs:{"name":"polls_enabled","inline-hint":_vm.$t('generic_form.video.polls_hint'),"on-label":"generic_form.video.polls_enabled","off-label":"generic_form.video.polls_enabled"},model:{value:(_vm.videoCallDoc.polls_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "polls_enabled", $$v)},expression:"videoCallDoc.polls_enabled"}}),_c('toggler',{attrs:{"name":"slides_enabled","inline-hint":_vm.$t('generic_form.video.slides_hint'),"on-label":"generic_form.video.slides_enabled","off-label":"generic_form.video.slides_enabled"},model:{value:(_vm.videoCallDoc.slides_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "slides_enabled", $$v)},expression:"videoCallDoc.slides_enabled"}},[(_vm.videoCallDoc.slides_enabled)?_c('div',{staticClass:"feature-dependant"},[_c('video-call-item-uploader',{attrs:{"video-call-id":_vm.videoCallDocId,"fp-type":"slideshow","uploader-scope":"video-call-slides","attachment-specs":_vm.slideShowAttachmentSpecs,"upload-button-label":_vm.$t('generic_form.video.slides_upload_button'),"upload-modal-title":_vm.$t('generic_form.video.slides_modal_title'),"upload-modal-subtitle":_vm.$t('generic_form.video.slides_modal_subtitle'),"removal-confirmation-title":_vm.$t('generic_form.video.slides_delete_title'),"removal-confirmation-text":_vm.$t('generic_form.video.slides_delete_text'),"has-unsaved-changes":_vm.hasUnsavedSlideshowChanges,"unsaved-changes-text":_vm.$t('generic_form.video.slides_unsaved_changes'),"check-is-processing":function (slideshow) { return !slideshow.error && (!slideshow.slideIds || !slideshow.slideIds.length); },"get-error-info-text":function (error) { return ['page_limit_exceeded'].includes(error) ? _vm.$t(("generic_form.video.slides_error_infos." + error)) : null; },"get-items-content":function (itemIds) { return _vm.$services.videoCalls.getSlideshowsContent(_vm.event._id, _vm.videoCallDocId, itemIds); }},model:{value:(_vm.videoCallDoc.slideshow_ids),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "slideshow_ids", $$v)},expression:"videoCallDoc.slideshow_ids"}})],1):_vm._e()]),_c('toggler',{attrs:{"name":"virtual_backgrounds_enabled","on-label":"generic_form.video.virtual_backgrounds_enabled","off-label":"generic_form.video.virtual_backgrounds_enabled","inline-hint":_vm.$t('generic_form.video.virtual_backgrounds_description')},model:{value:(_vm.videoCallDoc.virtual_backgrounds_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "virtual_backgrounds_enabled", $$v)},expression:"videoCallDoc.virtual_backgrounds_enabled"}},[(_vm.videoCallDoc.virtual_backgrounds_enabled)?_c('div',{staticClass:"feature-dependant"},[_c('video-call-item-uploader',{attrs:{"video-call-id":_vm.videoCallDocId,"fp-type":"video_call_virtual_background","uploader-scope":"video-call-virtual-backgrounds","attachment-specs":_vm.backgroundAttachmentSpecs,"upload-button-label":_vm.$t('generic_form.video.virtual_backgrounds_upload_button'),"upload-modal-title":_vm.$t('generic_form.video.virtual_backgrounds_modal_title'),"upload-modal-warning":_vm.$t('generic_form.video.virtual_backgrounds_modal_warning'),"removal-confirmation-title":_vm.$t('generic_form.video.virtual_backgrounds_delete_title'),"removal-confirmation-text":_vm.$t('generic_form.video.virtual_backgrounds_delete_text'),"has-unsaved-changes":_vm.hasUnsavedVirtualBackgroundChanges,"unsaved-changes-text":_vm.$t('generic_form.video.virtual_backgrounds_unsaved_changes'),"check-is-processing":function (bg) { return !bg.error && !bg.fileName; },"get-items-content":function (itemIds) { return _vm.$services.videoCalls.getVirtualBackgroundsContent(_vm.event._id, _vm.videoCallDocId, itemIds); }},model:{value:(_vm.videoCallDoc.virtual_background_ids),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "virtual_background_ids", $$v)},expression:"videoCallDoc.virtual_background_ids"}})],1):_vm._e()]),_c('toggler',{attrs:{"name":"captions_enabled","on-label":"generic_form.video.captions_enabled","off-label":"generic_form.video.captions_enabled"},model:{value:(_vm.videoCallDoc.captions_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "captions_enabled", $$v)},expression:"videoCallDoc.captions_enabled"}},[(_vm.videoCallDoc.captions_enabled)?_c('div',{staticClass:"feature-dependant"},[_c('language-select',{attrs:{"name":"captions_language","label":_vm.$t('generic_form.video.captions_label'),"hint":_vm.$t('generic_form.video.captions_hint'),"restricted-language-codes":_vm.possibleCaptionsLanguages},model:{value:(_vm.videoCallDoc.captions_language),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "captions_language", $$v)},expression:"videoCallDoc.captions_language"}})],1):_vm._e()]),_c('toggler',{attrs:{"name":"embedded_url_enabled","on-label":"generic_form.video.embed","off-label":"generic_form.video.embed"},model:{value:(_vm.videoCallDoc.embedded_url_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "embedded_url_enabled", $$v)},expression:"videoCallDoc.embedded_url_enabled"}},[(_vm.videoCallDoc.embedded_url_enabled)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"url","slim":true,"name":"embedded_url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.videoCallDoc.embedded_url_enabled)?_c('base-input',{attrs:{"name":"embedded_url","label":_vm.$t('generic_form.video.url'),"errors":errors,"hint":_vm.$t('generic_form.video.embed_hint'),"hint-after-label":true},model:{value:(_vm.videoCallDoc.embedded_url),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "embedded_url", $$v)},expression:"videoCallDoc.embedded_url"}}):_vm._e()]}}],null,false,987819478)})],1):_vm._e()]),_c('toggler',{attrs:{"name":"recordings_enabled","inline-hint":_vm.videoCallDoc.recording_enabled ? _vm.$t('generic_form.video.recordings.hint') : '',"on-label":"generic_form.video.recordings.enabled","off-label":"generic_form.video.recordings.enabled"},model:{value:(_vm.videoCallDoc.recording_enabled),callback:function ($$v) {_vm.$set(_vm.videoCallDoc, "recording_enabled", $$v)},expression:"videoCallDoc.recording_enabled"}},[_c('div',{staticClass:"feature-dependant"},[_c('video-call-recordings',{attrs:{"event":_vm.event,"video-call-doc":_vm.videoCallDoc,"base-name":_vm.model.name},on:{"transcription-requested":_vm.fetchVideoCallDoc}})],1)]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"moderators"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('radio-buttons',{staticClass:"moderators",attrs:{"name":"moderators","label":_vm.$t('generic_form.video.video_call_moderators'),"hint":_vm.$t('generic_form.video.everyone_is_moderator_hint'),"options":_vm.moderatorOptions,"errors":errors},model:{value:(_vm.moderatorValue),callback:function ($$v) {_vm.moderatorValue=$$v},expression:"moderatorValue"}}),(!_vm.everyoneIsModerator)?_c('meta-control',{attrs:{"settings":_vm.settings,"event":_vm.event,"edit":_vm.edit,"control":_vm.moderatorField.video_call_moderators},model:{value:(_vm.model.video_call_moderators),callback:function ($$v) {_vm.$set(_vm.model, "video_call_moderators", $$v)},expression:"model.video_call_moderators"}}):_vm._e()]}}],null,false,2142382974)})]:_vm._e()],2):_vm._e(),(!_vm.isCallScheduled)?_c('video-call-recordings',{attrs:{"event":_vm.event,"video-call-doc":_vm.videoCallDoc,"base-name":_vm.model.name},on:{"transcription-requested":_vm.fetchVideoCallDoc}}):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "VideoCallControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__